var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _rect, _rect2, _rect3, _rect4, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 118,
    viewBox: "0 0 314 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0196 -6.3619V83.7298H91.5049V95.742H77.0196V118H63.9475V95.742H3.53301L77.0196 -6.3619ZM26.6742 83.7298H63.9475V31.6179L26.6742 83.7298Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_496_20116)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.728 115H209.795C211.558 115 212.991 113.573 213 111.817V6.1914C213 4.42701 211.567 3 209.795 3H103.728C101.956 3 100.523 4.42701 100.523 6.1914V111.809C100.523 113.573 101.956 115 103.728 115ZM207.563 59.0001C207.563 86.9426 184.817 109.595 156.757 109.595C128.698 109.595 105.951 86.9426 105.951 59.0001C105.951 31.0574 128.698 8.40541 156.757 8.40541C184.817 8.40541 207.563 31.0574 207.563 59.0001ZM111.528 101.828H104.736V104.526H111.528V111.293H114.237V104.526H121.028V101.828H114.237V95.0684H111.528V101.828ZM199.741 13.5254H192.947V16.2238H199.741V22.9796H202.451V16.2238H209.24V13.5254H202.451V6.75473H199.741V13.5254ZM209.213 111.048L194.597 107.138L205.279 96.5005L207.242 103.774L209.213 111.048ZM113.681 9.27022L104.597 6.83129L109.486 24.9416L122.774 11.7005L113.681 9.27022Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.336 5.85957H123.877V16.3447L104.336 28.9745V5.85957Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.506 6.33617H210.14V23.017L199.655 23.9702L191.792 19.6809L192.506 6.33617Z",
    fill: "#282828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.792 100.702L201.085 92.6L210.617 92.1234V113.094H190.6L191.792 100.702Z",
    fill: "#282828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.86 94.0298H117.204L121.97 102.132L121.494 112.617H103.86V94.0298Z",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_496_20116",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 10,
    width: 96,
    height: 97
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.956 106.996C183.255 106.996 204.573 85.4927 204.573 58.9661C204.573 32.4396 183.255 10.9355 156.956 10.9355C130.658 10.9355 109.339 32.4396 109.339 58.9661C109.339 85.4927 130.658 106.996 156.956 106.996Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_496_20116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.321 23.8103C151.555 25.1963 148.945 26.4428 146.396 27.794C132.897 34.9594 120.582 43.7461 110.125 55.0257C104.594 60.9968 99.7031 67.4562 96.7908 75.1619C95.7451 77.9341 95.339 80.9501 94.6389 83.8616C94.5784 84.1231 94.5352 84.3846 94.4834 84.6461C94.3624 84.6722 94.2414 84.6897 94.1204 84.7158C93.1784 81.5952 92.0636 78.5093 91.3291 75.3362C87.276 57.9983 89.497 41.4882 97.9315 25.8152C100.628 20.803 105.035 18.3535 110.255 17.0459C115.725 15.6774 121.282 15.7384 126.83 16.3486C136.051 17.3597 144.875 19.9836 153.482 23.4006C153.698 23.4878 153.914 23.6098 154.321 23.8103Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.706 33.4341C220.536 36.0317 221.478 38.6032 222.161 41.2359C226.689 58.6523 224.727 75.3368 216.552 91.3411C213.717 96.885 209.137 99.8227 203.338 101.156C197.782 102.438 192.173 102.351 186.538 101.714C177.49 100.686 168.874 98.0617 160.431 94.7582C160.215 94.6707 160.007 94.5489 159.584 94.3396C160.129 94.0695 160.526 93.8516 160.932 93.6598C176.427 86.3463 190.496 76.9667 202.466 64.5451C208.515 58.2687 213.752 51.4085 217.079 43.2234C218.28 40.2771 219.11 37.2348 219.283 34.0356C219.292 33.8527 219.343 33.6695 219.378 33.4866C219.49 33.4777 219.602 33.4516 219.706 33.4341Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.56 74.3689C188.742 71.3527 188.966 68.4849 189.079 65.6169C189.753 48.9239 188.111 32.5187 182.684 16.645C180.307 9.69761 177.239 3.08143 172.408 -2.51485C170.732 -4.45874 168.649 -6.04525 166.748 -7.78864C166.584 -7.93681 166.394 -8.06758 166.221 -8.20704C166.255 -8.30295 166.29 -8.40754 166.324 -8.50342C168.632 -8.03272 170.965 -7.68402 173.238 -7.08255C190.911 -2.44512 204.591 7.71886 214.452 23.2176C217.848 28.5524 217.96 34.079 216.163 39.8758C214.218 46.1259 210.77 51.5215 206.778 56.6124C201.627 63.1851 195.586 68.8336 189.105 74.0374C188.984 74.1249 188.846 74.1946 188.56 74.3689Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.093 43.9727C124.955 50.3449 124.583 56.7171 124.721 63.0804C125.041 77.4198 127.158 91.4628 132.422 104.887C135.075 111.651 138.445 118.015 143.708 123.149C144.918 124.326 146.283 125.346 147.813 126.636C146.37 126.409 145.143 126.27 143.932 126.017C124.246 121.815 109.157 111.032 98.7005 93.6943C95.7622 88.8127 96.0906 83.6174 97.6807 78.4222C99.6424 72.0064 103.22 66.48 107.342 61.2933C112.424 54.8864 118.352 49.3336 124.704 44.243C124.868 44.1034 125.041 44.0076 125.093 43.9727Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.972 79.0586C130.841 80.9678 133.477 82.8157 136.208 84.5242C148.445 92.2039 161.399 98.236 175.442 101.732C183.306 103.684 191.265 104.713 199.38 103.858C203.157 103.458 206.778 102.499 210.321 100.93C209.431 102.011 208.575 103.109 207.651 104.155C196.831 116.35 183.427 123.855 167.405 126.401C163.499 127.02 159.472 127.124 155.505 127.046C151.789 126.967 148.712 124.971 145.981 122.53C141.142 118.215 137.988 112.715 135.404 106.857C131.783 98.6283 129.605 89.981 128.283 81.0986C128.179 80.4884 128.093 79.8694 127.972 79.0586Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.853 17.2643C107.534 12.1387 111.967 7.79766 117.014 4.09296C128.482 -4.32764 141.333 -8.65123 155.497 -9.08709C160.414 -9.23527 164.519 -7.46572 168.097 -4.20559C172.703 -0.012722 175.78 5.25232 178.295 10.866C181.838 18.8072 184.033 27.1581 185.398 35.7443C185.571 36.8166 185.744 37.8886 185.951 39.17C183.419 37.4703 181.112 35.8575 178.744 34.3494C167.034 26.8791 154.659 20.8731 141.255 17.1597C133.071 14.8933 124.766 13.5596 116.245 14.1001C112.296 14.3528 108.459 15.1722 104.82 16.811C104.492 16.9679 104.172 17.1161 103.853 17.2643Z",
    fill: "#282828"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.957 33.1548L168.46 53.2474L179.954 73.3314H156.957H133.961L145.463 53.2474L156.957 33.1548Z",
    stroke: "#282828",
    strokeWidth: 3.81277,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.419 57.9722H151.504V59.9597H162.419V57.9722Z",
    fill: "#282828"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.945 64.4773V53.4678H155.975V64.4773H157.945Z",
    fill: "#282828"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199.829,
    y: 6.4751,
    width: 2.95448,
    height: 16.4666,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 209.513,
    y: 13.2266,
    width: 2.96399,
    height: 16.4138,
    transform: "rotate(90 209.513 13.2266)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111.358,
    y: 95.0659,
    width: 2.95448,
    height: 16.4666,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 121.042,
    y: 101.817,
    width: 2.96399,
    height: 16.4138,
    transform: "rotate(90 121.042 101.817)",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.771 6.86859L122.725 11.6989L109.399 24.9287L104.771 6.86859Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.484 111.01L191.506 106.273L204.763 92.9741L209.484 111.01Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M290.02 -6.3619V83.7298H304.505V95.742H290.02V118H276.947V95.742H216.533L290.02 -6.3619ZM239.674 83.7298H276.947V31.6179L239.674 83.7298Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_496_20116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112.953,
    fill: "white",
    transform: "translate(101 2.52344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.4400bc49c151a8f89ba316ded4cce588.svg";
export { ForwardRef as ReactComponent };